'use strict';

const SectionModel = require('../models/section');
const BaseCollection = require('./base');

class SectionsCollection extends BaseCollection {
  initialize() {
    this.model = SectionModel;
  }

  getCheapest() {
    return this.min(price => price.getPrice());
  }

  getMostDiscounted() {
    return this.max(price => parseFloat(price.getDiscount()));
  }
}

module.exports = SectionsCollection;
